import React from "react";

import BtnParallax from "../../components/Elements/BtnParallax";
import BtnParallaxSlider from "../../components/Elements/BtnParallaxSlider";
import SliderBulletProgress from "../../components/Elements/SliderBulletProgress";

import {
	isTablet,
} from "../../hooks/isMobile";

import styles from "../Solutions.module.css";

const SolutionsControls = ({
	cases,

	activeSlide,
	isPortraitMode,
	isCurrentlyHovered,

	overlayInTrans,

	btnTimelineCntRef,
	progressBarRef,
	bulletProgressBarRef,

	btnParallaxWatchRef,
	btnParallaxSliderRef,

	fullscreenSolutionRef,

	handleArrowClick,
	handleBulletClick,
	handleVideoModalOpen,

	clearHoverTimeout,
	setActiveVideo,
	handleHover,
	setHoverTimeout,
}) => {
	const caseItems =
		cases?.[0] ?? [];

	const activeCase =
		caseItems?.[
			activeSlide
		];

	return (
		<div
			className={`solution-fs-wrapper ${styles.pointerNone}`}
			ref={
				btnTimelineCntRef
			}
		>
			<div className="sol-fs-content-wrapper">
				<div
					className="sol-fs-spacer-cnt"
					style={{
						marginBottom:
							isPortraitMode
								? isTablet
									? -75
									: 5
								: null,
					}}
				>
					{!isPortraitMode ? null : (
						<div
							className={`sol-fs-btn-parallax-cnt-arrow left${
								activeSlide >
									0 &&
								!isCurrentlyHovered
									? " active"
									: ""
							} ${styles.pointerAll}`}
							onClick={() => {
								handleArrowClick(
									-1,
								);
							}}
						>
							<div
								className={`sol-fs-btn-hover arrow ${styles.opacityZero}`}
							>
								<div className="hover-btn-circle arrow">
									&lt;
								</div>
							</div>
						</div>
					)}

					{isPortraitMode ? (
						<div
							className={`sol-fs-progressbar-bullet ${styles.pointerAll} ${styles.opacityZero}`}
						>
							<SliderBulletProgress
								entryLength={
									caseItems.length
								}
								ref={
									bulletProgressBarRef
								}
								onclick={
									handleBulletClick
								}
							/>
						</div>
					) : (
						<div className="sol-fs-progressbar">
							<div
								className="sol-fs-progressbar-fill"
								ref={
									progressBarRef
								}
							/>
						</div>
					)}

					{!isPortraitMode ? null : (
						<div
							className={`sol-fs-btn-parallax-cnt-arrow right${
								activeSlide <
									caseItems.length -
										1 &&
								!isCurrentlyHovered
									? " active"
									: ""
							} ${styles.pointerAll}`}
							onClick={() => {
								handleArrowClick(
									1,
								);
							}}
						>
							<div
								className={`sol-fs-btn-hover arrow ${styles.opacityZero}`}
							>
								<div className="hover-btn-circle arrow">
									&gt;
								</div>
							</div>
						</div>
					)}
				</div>

				<div
					className={`sol-fs-btn-cnt${
						isPortraitMode
							? ""
							: " landscape"
					} ${styles.pointerNone}`}
				>
					<div className="sol-fs-btn-timeline-spacer hidden" />

					{activeCase?.type !==
					"work" ? null : (
						<BtnParallax
							ref={
								btnParallaxWatchRef
							}
							manualtext
							landing
							disabled={
								overlayInTrans
							}
							defaulthide
							filled
							text={
								activeCase?.[
									"film-btn-custom-name"
								]?.length >
								0
									? activeCase?.[
											"film-btn-custom-name"
									  ]
									: "Watch Film"
							}
							filmicon
							addclass="btn-parallax-sol-pseudo"
							small
							onclick={() => {
								handleVideoModalOpen(
									true,
								);
							}}
						/>
					)}

					{activeCase?.type ===
					"work" ? null : (
						<div
							className={
								styles.opacityZero
							}
						>
							<div
								key="spacer_select_3"
								className="sol-fs-btn-timeline-spacer"
								style={{
									opacity:
										0,

									visibility:
										"hidden",
								}}
							/>
						</div>
					)}

					{activeCase?.type ===
					"solution" ? (
						<BtnParallaxSlider
							ref={
								btnParallaxSliderRef
							}
							manualtext
							activeSlideData={
								activeCase
							}
							addclass="btn-parallax-sol-pseudo"
							defaulthide
							invert
							isCurrentlyHovered={
								isCurrentlyHovered
							}
							onclick={() => {}}
							onmousemove={(
								i,
							) => {
								clearHoverTimeout();

								setActiveVideo(
									i,
								);

								handleHover(
									true,
									false,
									i,
								);
							}}
							onmouseleave={() => {
								setHoverTimeout();
							}}
						/>
					) : null}

					{activeCase?.type ? (
						<BtnParallax
							landing
							more
							small
							disabled={
								overlayInTrans
							}
							defaulthide
							addclass="btn-parallax-sol-pseudo more"
							content={
								<div
									className={`btn-dots-cnt ${styles.moreDots}`}
								>
									<div className="btn-dot" />

									<div className="btn-dot" />

									<div className="btn-dot" />
								</div>
							}
							onclick={() => {
								fullscreenSolutionRef
									.current
									?.handleClickMoreBtn?.();
							}}
						/>
					) : null}

					<div className="sol-fs-btn-timeline-spacer hidden" />
				</div>
			</div>
		</div>
	);
};

export default React.memo(
	SolutionsControls,
);